import { fetchApiQuery } from "api";
import { useEffect } from "react";
import { useParams } from "react-router";
import { GetSSOResponse } from "../../api/routes/sso";
import useSession from "../../hooks/useSession";
import { processSSOResponse } from "../../utils/sso/processSSOResponse";

const componentName = "ssoPage";

const SSOPage = () => {
  const { ssoslug } = useParams<{
    ssoslug: string;
  }>();

  const { society } = useSession();
  const ssoRouteConfig = society!.routes!.find(
    (route) =>
      route.componentName === componentName &&
      Object.values(route.pathParam).includes(ssoslug),
  );

  useEffect(() => {
    if (ssoRouteConfig?.pathParam?.ssoId) {
      fetchApiQuery(GetSSOResponse, {
        societyId: society?.id.toString(),
        ssoConfigId: ssoRouteConfig?.pathParam?.ssoId,
      }).then(({ data }) => {
        return processSSOResponse(data.body?.ssoResponse, data.body?.ssoConfig);
      });
    }
  }, []);

  return <div></div>;
};

export default SSOPage;
